<template>
  <div class="left-nav NoSelect" :style="{display:isshow}">
    <div id="side-nav" :class="{'scrollbar':isScroll}">
      <ul id="nav">
        <li class="side-nav-row" v-for="(item,index) in navdatas" v-bind:key="index" :class="[{'open':item.active && item.subMenu},{'openx':item.active && !item.subMenu}]">
          <a>
            <i class="fa" :class="item.icon"></i>
            <cite v-text="item.title"></cite>
            <i class="iconfont nav_right">&#xe6a7;</i>
          </a>
          <ul class="sub-menu">
            <li :class="{'menu-current':val.active}" v-for="val in item.subMenu">
              <a>
                <!-- <i class="iconfont" v-text="'&#'+val.icon"></i><cite v-text="val.title"></cite> -->
                <i class="iconfont">&#xe6a7;</i><cite v-text="val.title"></cite>
              </a>
            </li>
          </ul>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
  var self;
  import {
    NavList
  } from '../../../static/js/LeftNav.js'
  export default {
    name: 'LeftNav',
    data() {
      return {
        isshow: "block",
        isScroll: false,
        navdatas: [],
        isNone: ["Login", "Edit", "EditGlobal", "Bulk", "BulkGlobal", "Detail", "DetailGlobal", "Authorization", "Print"],
        NoJump: ["Login"],
        ProductRebate: {
          active: false,
          icon: "fa-star-half-o",
          title: "推广返利",
          url: "ProductPromote",
          subMenu: [{
            active: true,
            icon: "xe6cb",
            title: "推广列表",
            url: "ProductPromote",
          }, {
            active: false,
            icon: "xe6f6",
            title: "返佣记录",
            url: "RebateRecord",
          }, {
            active: false,
            icon: "xe6f6",
            title: "余额管理",
            url: "BalanceManage",
          }]
        }
      }
    },
    watch: {
      $route: {
        handler(nv, ov) {
          $('.pagebox').hide(); //隐藏分页
          if (self.isInArray(self.isNone, self.$route.name)) {
            self.isshow = "none";
          } else {
            self.isshow = "block";
          }
          if (nv.query.te) {
            localStorage.setItem("ExShopee_NavSubIx", nv.query.te); //缓存二级导航索引
          }
          if (ov.name == "Login") {
            self.NavMain();
          }else{
            self.leftNavActive();
          }
        }
      },
      deep: true
    },
    updated() {

      //一级导航点击
      $('.left-nav #nav li').click(function(event) {
        // localStorage.removeItem("ExShopee_NavSubIx"); //清除二级导航索引
        self.leftNavActive($(this), event)
      })

      //二级导航点击
      $('.left-nav #nav li .sub-menu li ').click(function() {
        let pix = $(this).parents('.left-nav #nav li').index();
        let ix = $(this).index();
        let url = self.navdatas[pix].subMenu[ix].url; //获取二级导航URL

        self.GoToPage(url); // 路由跳转
        localStorage.setItem("ExShopee_HistoryURL", self.navdatas[pix].url); //缓存一级导航URL
        localStorage.setItem("ExShopee_NavSubIx", ix); //缓存二级导航索引

        $(this).addClass('menu-current').siblings().removeClass('menu-current');
      })

      //等导航动画执行完毕
      setTimeout(function() {
        var winh = $(window).height() + 56;
        var boxh = $('#nav').height();
        if (boxh > winh) {
          self.isScroll = true; //隐藏下拉导航
        }
      }, 500)
    },
    mounted() {
      self = this;
      if (self.isInArray(self.isNone, self.$route.name)) {
        self.isshow = "none";
      } else {
        self.isshow = "block";
      }

      //监听浏览器返回
      window.addEventListener("popstate", function(e) {

        //返回时关闭弹窗
        if (typeof layer != "undefined") {
          layer.closeAll()
        }

        //先清除所有激活状态并找到栈顶页
        for (let item in self.navdatas) {
          self.navdatas[item].active = false;

          if (self.navdatas[item].url == self.$route.name) {
            localStorage.setItem("ExShopee_HistoryURL", self.$route.name);
            self.leftNavActive();
            return;
          } else {
            for (let x in self.navdatas[item].subMenu) {
              if (self.navdatas[item].subMenu[x].url == self.$route.name) {
                localStorage.setItem("ExShopee_HistoryURL", self.navdatas[item].url);
                localStorage.setItem("ExShopee_NavSubIx", x); //缓存二级导航索引
                self.leftNavActive();
                return;
              }
            }
          }
        }

      }, false);

      //加载完成
      $(document).ready(function() {
        self.$emit('LoadingCompleted');
      });

    },
    methods: {
      NavMain() {
        self.navdatas = [];
        setTimeout(function() {

          var hyURL = localStorage.getItem("ExShopee_HistoryURL");
          var sort = localStorage.getItem("ExShopee_Sort");
          var isShow;
          if (localStorage.getItem('ExShopee_Role') == 10) {
            if (sort == "上架") {
              self.navdatas = NavList.adminProductNav;
            }else if (sort == "金融") {
              self.navdatas = NavList.adminFinanceNav;
            } else {
              self.navdatas = NavList.adminLogisticsNav;
            }
            for(let i in self.navdatas){
              if(self.navdatas[i].url == hyURL){
                isShow = true;
              }
            }
            if(!isShow && !self.isInArray(self.NoJump, self.$route.name)){
              if(sort == "货代"){
                localStorage.setItem("ExShopee_HistoryURL","AdminHome");
                self.GoToPage("AdminHome");
              }else if(sort == "上架"){
                localStorage.setItem("ExShopee_HistoryURL","AdminProHome");
                self.GoToPage("AdminProHome");
              }else if(sort == "金融"){
                localStorage.setItem("ExShopee_HistoryURL","AdminFinHome");
                self.GoToPage("AdminFinHome");
              }
            }
          } else if (localStorage.getItem('ExShopee_Role') == 20) {
            if(localStorage.getItem("ExShopee_id") == 2){
              self.navdatas = NavList.deliverymanNav;  //自营
            }else{
              // self.navdatas = NavList.deliverymanNav;  //外放
              self.navdatas = NavList.autonomyDeliverymanNav;  //外放
            }
          } else {
            if (sort == "上架") {
              self.navdatas = JSON.parse(JSON.stringify(NavList.productNav));
              if(localStorage.getItem("ExShopee_isrebate") == "1"){
                self.navdatas.push(self.ProductRebate);
              }
            } else if (sort == "管理") {
              self.navdatas = NavList.manageNav;
            } else {
              self.navdatas = NavList.logisticsNav;
            }
            for(let i in self.navdatas){
              if(self.navdatas[i].url == hyURL){
                isShow = true;
              }
            }
            if(!isShow && !self.isInArray(self.NoJump, self.$route.name)){
              if(sort == "货代"){
                localStorage.setItem("ExShopee_HistoryURL","UserHomePage");
                self.GoToPage("UserHomePage");
              }else if(sort == "上架"){
                localStorage.setItem("ExShopee_HistoryURL","HomePage");
                self.GoToPage("HomePage");
              }else if(sort == "管理"){
                localStorage.setItem("ExShopee_HistoryURL","ManageHomePage");
                self.GoToPage("ManageHomePage");
              }
            }

          }
        }, 50)
        setTimeout(function() {
          self.leftNavActive();
        }, 100)
      },
      leftNavActive($this, event) {

        //点击触发
        if ($this) {

          let ix = $this.index(); //导航索引

          if ($this.children('.sub-menu').length) {

            if ($this.hasClass('open')) {
              //如果点击有二级导航的内容触发
              if ($this.children('.sub-menu').children('li').length > 0) {
                localStorage.setItem("ExShopee_NavSubIx", '0'); //缓存二级导航索引
                var navlist = self.navdatas[ix].subMenu;
                var url = navlist[0].url; //二级导航url
                self.GoToPage(url); // 路由跳转
              } else {
                $this.removeClass('open');
                $this.children('.sub-menu').stop().slideUp();
                $this.siblings().children('.sub-menu').slideUp();
              }

            } else {
              //二级导航不为空才修改箭头
              localStorage.setItem("ExShopee_HistoryURL", self.navdatas[ix].url); //缓存父类URL
              if ($this.children('.sub-menu').children('li').length > 0) {
                $this.children('a').find('.nav_right').html('&#xe6a6;');
                $this.addClass('open');

                localStorage.setItem("ExShopee_NavSubIx", '0'); //缓存二级导航索引
                var navlist = self.navdatas[ix].subMenu;
                var url = navlist[0].url; //二级导航url

                self.GoToPage(url); // 路由跳转
              } else {
                self.GoToPage(self.navdatas[ix].url); // 路由跳转
                $this.addClass('openx');
              }

              $this.children('.sub-menu').stop().slideDown();
              $this.siblings().children('.sub-menu').stop().slideUp();
              $this.siblings().find('.nav_right').html('&#xe6a7;');
              $this.siblings().removeClass('open');
              $this.siblings().removeClass('openx');
            }

          } else {
            var url = $this.children('a').attr('_href');
            var title = $this.find('cite').html();
            var index = $('.left-nav #nav li').index($this);
          }

          event.stopPropagation();
        } else {
          $('.side-nav-row').children('.sub-menu').stop().slideUp(); //默认关闭所有二级展开
          var hyURL = localStorage.getItem("ExShopee_HistoryURL");
          if (hyURL) {
            for (let item in self.navdatas) {

              self.navdatas[item].active = false;
              if (self.navdatas[item].url == hyURL) {
                self.navdatas[item].active = true;

                //二级导航不为空
                if (localStorage.getItem("ExShopee_NavSubIx")) {
                  self.SubMenu(item);
                }
              }
            }
          } else {
            self.navdatas[0].active = true;
          }
        }
      },
      SubMenu(pix) {
        let six = localStorage.getItem("ExShopee_NavSubIx");
        $('.side-nav-row').eq(pix).children('.sub-menu').stop().height("auto").slideDown();
        $('.side-nav-row').eq(pix).children('.sub-menu').find('li').eq(six).addClass('menu-current').siblings().removeClass(
          'menu-current');
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .left-nav {
    position: absolute;
    top: 55px;
    bottom: 0px;
    left: 0;
    z-index: 2;
    padding-top: 10px;
    background-color: #000;
    width: 220px;
    max-width: 220px;
    overflow: hidden;
    border-right: 1px solid #131e26;

    /*width: 0px;*/
  }

  #side-nav {
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    width: 221px;
  }

  .scrollbar {
    width: 240px !important;
    overflow-y: auto;
  }

  .left-nav #nav>li {
    line-height: 30px;
    border-left: 4px solid #000;
    transition: background-color ease .3s
  }

  .left-nav #nav>li:hover {
    background: #1a1a1a;
    border-left: 4px solid #42b8f1;
  }

  .left-nav #nav>li.open {
    border-left: 4px solid #42b8f1;
    background: #1a1a1a;
  }

  .left-nav #nav>li.openx {
    border-left: 4px solid #42b8f1;
    background: #1a1a1a;
  }

  .left-nav #nav>li.openx>a {
    color: #FFF !important;
  }

  /* .left-nav-active {
    background: #181818;
    border-left: 4px solid #42b8f1 !important;
  }

  .left-nav-active a {
    color: #FFF !important;
  } */

  .left-nav #nav li a:hover {
    color: white;
  }

  .left-nav #nav .current {
    background: #41b8f0;
  }

  .left-nav #nav li a {
    font-size: 14px;
    padding: 12px 15px 12px 20px;
    display: block;
    cursor: pointer;
    color: #8e8e8e;
    transition: background-color ease .3s;
  }

  .left-nav #nav li a cite {
    font-size: 14px;
  }

  .left-nav #nav li .sub-menu {
    display: none;
  }

  .left-nav #nav li .opened {
    display: block;
    background: #454648;
  }

  .left-nav #nav li .opened:hover {
    /*background: #fff url() 0 0 no-repeat;*/
  }

  .left-nav #nav li .opened .current {}

  .left-nav #nav li .sub-menu li {
    background: #1a1a1a;
    transition: background-color ease .3s
      /*color: blue;*/
      /*background: #fff url() 0 0 no-repeat;*/
  }

  .left-nav #nav li .sub-menu li:hover {
    background: #303235;
    /*color: blue;*/
    /*background: #fff url() 0 0 no-repeat;*/
  }

  .left-nav #nav li .sub-menu li a {
    padding: 10px 15px 10px 30px;
    font-size: 14px;
    cursor: pointer;
    color: #8e8e8e;
  }

  .left-nav #nav li .sub-menu li .sub-menu li a {
    padding-left: 45px;
  }

  /*点击当前菜单显示效果*/
  .menu-current {
    background: #282b33 !important;
  }

  .menu-current>a {
    color: #fff !important;
  }

  .left-nav #nav li .sub-menu li a:hover {
    color: #fff;
  }

  .left-nav #nav li .sub-menu li a i {
    font-size: 12px;
  }

  .left-nav #nav li a i {
    padding-right: 10px;
    padding-top: 8px;
    line-height: 14px;
  }

  .left-nav #nav li .nav_right {
    float: right;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LeftNav.vue